<!--suppress ALL -->

<template>
  <el-dialog top="10px"
    width="95%"
    :visible.sync="isVisible"
    :close-on-click-modal="false" :close-on-press-escape="false" :fullscreen="false" :append-to-body="true"
    :title="title">
    <p style="font-size: 20px">{{item.product && item.product.name}}</p>

    <p style="font-size: 22px; color: #ec5e17">价格: {{item.product && item.product.priceText}}</p>

    <div v-html="item.product && item.product.intro"></div>
  </el-dialog>
</template>


<script>
export default {
  name: 'ProductDisplay',
  data() {
    return {
      title: '购买商品',
      item:{},
      isVisible: false,
    }
  },

  components: {
  },
  methods: {
    init(item_id) {
      this.isVisible = true
      this.getProduct(item_id)
    },

    getProduct: function (item_id) {
      let t = this;
      this.$post(
        {
          context: t,
          path: '/product/detail/c/',
          params: {
            item_id: item_id
          },
          success: function (data) {
            t.item = data.item;
          }
        }
      )
    },

  }

}
</script>
<style scoped >
@import '../../assets/global.css';

.attach-container {
  display: flex;
  flex-wrap: wrap; /* 关键属性：允许自动换行 */
  gap: 10px; /* 可选：设置项目之间的间距 */
}

.attach-item {
  flex: 1 1 auto; /* 项目可以伸缩 */
  min-width: 150px; /* 设置最小宽度，防止项目过小 */
  max-width: 150px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
}

</style>
